class Hamburger {
	constructor() {
		this.init();
	}

	init() {
		$(".hamburger").on("click", function(e) {
			$(this).toggleClass("is-active");
		});
	}
}
export default new Hamburger();